export const timezoneConstants = {
  SET_TIMEZONE: 'SET_TIMEZONE',
}
